<template>
  <div>
    <q-banner v-if="error" class="text-white bg-red q-mb-md" rounded>
      {{ error.message }}
    </q-banner>

    <q-table
      v-model:pagination="pagination"
      :columns="tableColumns"
      :rows="history"
      :rows-per-page-options="[5, 10, 20, 50]"
      :loading="isLoading"
      :loading-label="$t('components.doctorCreditsHistory.loading')"
      :no-data-label="$t('components.doctorCreditsHistory.noItems')"
      row-key="id"
      flat
      bordered
      @request="onRequest"
    />
  </div>
</template>

<script>
import { getDoctorCreditsHistory } from '@/api/credits';

export default {
  props: {
    doctorId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      pagination: {
        page: 1,
        rowsPerPage: 5,
        rowsNumber: 0,
      },
      history: [],
      isLoading: false,
    };
  },
  computed: {
    tableColumns() {
      return [
        {
          name: 'dateTime',
          field: 'createdAt',
          format: (value) => this.$dayjs(value).format('L LT'),
          label: this.$t(
            'components.doctorCreditsHistory.tableColumns.dateTime'
          ),
          align: 'left',
        },
        {
          name: 'amount',
          field: 'change',
          format: (value) => this.$numeral(value).format('0,0'),
          label: this.$t('components.doctorCreditsHistory.tableColumns.amount'),
          align: 'center',
        },
        {
          name: 'direction',
          field: 'direction',
          label: this.$t(
            'components.doctorCreditsHistory.tableColumns.direction'
          ),
          align: 'left',
        },
      ];
    },
  },
  created() {
    this.onRequest({ pagination: this.pagination });
  },
  methods: {
    async onRequest({ pagination: { page, rowsPerPage } }) {
      try {
        this.isLoading = true;
        this.error = null;

        this.pagination.page = page;
        this.pagination.rowsPerPage = rowsPerPage;

        const { history, count } = await getDoctorCreditsHistory({
          filters: {
            userId: this.doctorId,
          },
          offset: (page - 1) * rowsPerPage,
          limit: rowsPerPage,
        });

        this.history = history;
        this.pagination.rowsNumber = count;
      } catch (error) {
        this.error = error;
      } finally {
        this.isLoading = false;
      }
    },
    addRow(transaction) {
      if (this.pagination.page === 1) {
        this.history.unshift(transaction);
        this.pagination.rowsNumber += 1;
      } else {
        this.pagination.page = 1;
        this.onRequest({ pagination: this.pagination });
      }
    },
  },
};
</script>
